import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import { getLibraryCategoryToneClassName, type LibraryCategory } from "@/lib/libraryCategories";

type LibraryCategoryBadgeProps = {
  category: Pick<LibraryCategory, "name" | "color">;
  className?: string;
  onClick?: () => void;
  onRemove?: () => void;
  selected?: boolean;
};

export const LibraryCategoryBadge = ({ category, className, onClick, onRemove, selected = false }: LibraryCategoryBadgeProps) => {
  const toneClassName = getLibraryCategoryToneClassName(category.color);
  const sharedClassName = cn(
    "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition",
    toneClassName,
    selected && "ring-2 ring-ring ring-offset-1 ring-offset-background",
    className,
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cn(sharedClassName, "hover:opacity-90")}> 
        <span className="truncate">{category.name}</span>
      </button>
    );
  }

  return (
    <span className={sharedClassName}>
      <span className="truncate">{category.name}</span>
      {onRemove ? (
        <button
          type="button"
          onClick={onRemove}
          className="rounded-full p-0.5 transition hover:bg-foreground/10"
          aria-label={`Remove ${category.name}`}
        >
          <X className="h-3 w-3" />
        </button>
      ) : null}
    </span>
  );
};
